import Widget from "components/widget/Widget";
import { setSelectedEmployee } from "features/employees/EmployeesSlice";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SecondaryButton from "ui/buttons/SecondaryButton";

export default function EmployeeDetails({ Data }) {
  let navigate = useNavigate();
  let url = window.location.pathname;
  let dispatch = useDispatch();

  return (
    <Widget
      heading={"Employee Details"}
      // component={function () {
      //   return (
      //     <div className="flex flex-col space-y-3">
      //       <SecondaryButton>
      //         <button
      //           onClick={() => {
      //             dispatch(setSelectedEmployee(Data));
      //             navigate(url + "/EditEmployeeDetails/Modal=true");
      //           }}
      //           className="text-orange-600"
      //         >
      //           Edit Employee Details
      //         </button>
      //       </SecondaryButton>
      //     </div>
      //   );
      // }}
    >
      <div className="p-3">
        <div className="grid grid-rows-5 grid-flow-col gap-4 text-sm">
          {Object.keys(Data).map((key, index) => {
            return (
              <div className="row-span-1 flex flex-col space-y-1.5">
                <div className="capitalize text-xs">
                  <p>
                    {key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, function (str) {
                        return str.toUpperCase();
                      })}
                  </p>
                </div>
                <div className=" font-semibold">
                  <p>{Data[key] ?? "N/A"}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Widget>
  );
}
